import React, { useState } from 'react'
import { useStaticQuery, StaticQuery, graphql } from 'gatsby'

let numeral = require('numeral')
numeral.nullFormat('')

export default () => {
  const data = useStaticQuery(query)
  const titre = data.allRsrlComptesXlsxRepartition.edges[0].node.TITRE
  return (
      <div className="text-content accordion-content accordion-table">
        <table>
          <tbody>
          <tr>
            <th />
            <th align="right"></th>
          </tr>
          {data.allRsrlComptesXlsxRepartition.edges.map(({ node }) => (
            <tr key={node.id} className={node.CLASSE}>
              <td>{node.LABEL}</td>
              <td align="right">
                {numeral(node.MONTANT || '')
                  .format('0.00')
                  .toString()
                  .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1'")}
              </td>

            </tr>
          ))}
          </tbody>
        </table>
      </div>
  )
}

const query = graphql`
  query {
  allRsrlComptesXlsxRepartition {
    edges {
      node {
        id
        CLASSE
        LABEL
        MONTANT
        TITRE
      }
    }
  }
}

`
